var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "profile_page_wrapper" } }, [
    _c("div", { staticClass: "bb-mobile-header" }, [
      _c("div", { staticClass: "bb-mobile-header-left" }, [
        _c(
          "button",
          {
            staticClass: "mobile-sidebar-btn",
            on: {
              click: function ($event) {
                return _vm.openMobileAside()
              },
            },
          },
          [
            _c(
              "svg",
              {
                staticClass: "feather feather-menu",
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [
                _c("line", {
                  attrs: { x1: "3", y1: "12", x2: "21", y2: "12" },
                }),
                _c("line", { attrs: { x1: "3", y1: "6", x2: "21", y2: "6" } }),
                _c("line", {
                  attrs: { x1: "3", y1: "18", x2: "21", y2: "18" },
                }),
              ]
            ),
          ]
        ),
      ]),
      _c("h1", [_vm._v(_vm._s(_vm.$t("profile.title")))]),
      _c("div", { staticClass: "bb-mobile-header-right" }),
    ]),
    _c(
      "div",
      { staticClass: "d-flex justify-content-between align-items-top" },
      [
        _c("div", { staticClass: "bb-profile-form-guide" }, [
          _c("div", { staticClass: "personal-details-guide" }, [
            _c("h4", [
              _vm._v(_vm._s(_vm.$t("profile.guide.personalDetails.title"))),
            ]),
            _c("p", { staticClass: "guide-description" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("profile.guide.personalDetails.description")) +
                  " "
              ),
            ]),
          ]),
          _c("div", { staticClass: "change-password-guide" }, [
            _c("h4", [
              _vm._v(_vm._s(_vm.$t("profile.guide.changePassword.title"))),
            ]),
            _c("p", { staticClass: "guide-description" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("profile.guide.changePassword.description")) +
                  " "
              ),
            ]),
          ]),
          !_vm.$hasRole(_vm.acl.roles.owner)
            ? _c("div", { staticClass: "change-cancellation-guide" }, [
                _c("h4", [
                  _vm._v(
                    _vm._s(_vm.$t("profile.guide.changeCancellation.title"))
                  ),
                ]),
                _c("p", { staticClass: "guide-description" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("profile.guide.changeCancellation.description")
                      ) +
                      " "
                  ),
                ]),
              ])
            : _vm._e(),
        ]),
        _c("div", { staticClass: "bb-profile-form-container" }, [
          _c("div", { staticClass: "bb-card profile-page-card" }, [
            _c("div", { staticClass: "bb-profile-picture-container" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.profilePictureUrl,
                      expression: "!profilePictureUrl",
                    },
                  ],
                  staticClass: "bb-profile-picture-placeholder",
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "36",
                        height: "39",
                        viewBox: "0 0 36 39",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M21 6H5C3.93913 6 2.92172 6.42143 2.17157 7.17157C1.42143 7.92172 1 8.93913 1 10V30M1 30V34C1 35.0609 1.42143 36.0783 2.17157 36.8284C2.92172 37.5786 3.93913 38 5 38H29C30.0609 38 31.0783 37.5786 31.8284 36.8284C32.5786 36.0783 33 35.0609 33 34V26M1 30L10.172 20.828C10.9221 20.0781 11.9393 19.6569 13 19.6569C14.0607 19.6569 15.0779 20.0781 15.828 20.828L21 26M33 15.5V26M33 26L29.828 22.828C29.0779 22.0781 28.0607 21.6569 27 21.6569C25.9393 21.6569 24.9221 22.0781 24.172 22.828L21 26M21 26L25 30M27 5H35M31 1V9M21 14H21.02",
                          stroke: "#99ACC2",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.profilePictureUrl,
                    expression: "profilePictureUrl",
                  },
                ],
                staticClass: "bb-profile-picture-preview",
                attrs: { src: _vm.profilePictureUrl },
              }),
              _c("input", {
                staticStyle: { display: "none" },
                attrs: { type: "file", id: "profile_picture_input" },
                on: { change: _vm.onFileChange },
              }),
              _c(
                "button",
                {
                  staticClass: "bb-profile-picture-btn",
                  on: { click: _vm.uploadImage },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("profile.personalDetailsCard.uploadAvatarBtn")
                      ) +
                      " "
                  ),
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.errors.avatar,
                      expression: "form.errors.avatar",
                    },
                  ],
                  staticClass: "bb-invalid-feedback",
                },
                [_vm._v(" " + _vm._s(_vm.form.errors.avatar) + " ")]
              ),
            ]),
            _c("div", { staticClass: "mobile-guide" }, [
              _c("h4", [
                _vm._v(_vm._s(_vm.$t("profile.guide.personalDetails.title"))),
              ]),
              _c("p", { staticClass: "mobile-guide-description" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("profile.guide.personalDetails.description")
                    ) +
                    " "
                ),
              ]),
            ]),
            _c("div", { staticClass: "bb-form-group inline-form-group" }, [
              _c("div", { staticClass: "bb-form-group mr-2" }, [
                _c("label", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("profile.personalDetailsCard.firstNameInput.label")
                    )
                  ),
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.fields.firstName,
                      expression: "form.fields.firstName",
                    },
                  ],
                  staticClass: "bb-input",
                  attrs: { type: "text" },
                  domProps: { value: _vm.form.fields.firstName },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.form.fields,
                        "firstName",
                        $event.target.value
                      )
                    },
                  },
                }),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.errors.firstName,
                        expression: "form.errors.firstName",
                      },
                    ],
                    staticClass: "bb-invalid-feedback",
                  },
                  [_vm._v(" " + _vm._s(_vm.form.errors.firstName) + " ")]
                ),
              ]),
              _c("div", { staticClass: "bb-form-group ml-2" }, [
                _c("label", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("profile.personalDetailsCard.lastNameInput.label")
                    )
                  ),
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.fields.lastName,
                      expression: "form.fields.lastName",
                    },
                  ],
                  staticClass: "bb-input",
                  attrs: { type: "text" },
                  domProps: { value: _vm.form.fields.lastName },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form.fields, "lastName", $event.target.value)
                    },
                  },
                }),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.errors.lastName,
                        expression: "form.errors.lastName",
                      },
                    ],
                    staticClass: "bb-invalid-feedback",
                  },
                  [_vm._v(" " + _vm._s(_vm.form.errors.lastName) + " ")]
                ),
              ]),
            ]),
            _c("div", { staticClass: "bb-form-group" }, [
              _c("label", [
                _vm._v(
                  _vm._s(_vm.$t("profile.personalDetailsCard.phoneInput.label"))
                ),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.fields.phone,
                    expression: "form.fields.phone",
                  },
                ],
                staticClass: "bb-input",
                attrs: { type: "text" },
                domProps: { value: _vm.form.fields.phone },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form.fields, "phone", $event.target.value)
                  },
                },
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.errors.phone,
                      expression: "form.errors.phone",
                    },
                  ],
                  staticClass: "bb-invalid-feedback",
                },
                [_vm._v(" " + _vm._s(_vm.form.errors.phone) + " ")]
              ),
            ]),
            _c("div", { staticClass: "bb-form-group" }, [
              _c("label", [
                _vm._v(
                  _vm._s(_vm.$t("profile.personalDetailsCard.emailInput.label"))
                ),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.fields.email,
                    expression: "form.fields.email",
                  },
                ],
                staticClass: "bb-input",
                attrs: { type: "email" },
                domProps: { value: _vm.form.fields.email },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form.fields, "email", $event.target.value)
                  },
                },
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.errors.email,
                      expression: "form.errors.email",
                    },
                  ],
                  staticClass: "bb-invalid-feedback",
                },
                [_vm._v(" " + _vm._s(_vm.form.errors.email) + " ")]
              ),
            ]),
            _c("hr"),
            _c("div", { staticClass: "mobile-guide" }, [
              _c("h4", [
                _vm._v(_vm._s(_vm.$t("profile.guide.changePassword.title"))),
              ]),
              _c("p", { staticClass: "mobile-guide-description" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("profile.guide.changePassword.description")) +
                    " "
                ),
              ]),
            ]),
            _c("div", { staticClass: "bb-form-group" }, [
              _c("label", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "profile.personalDetailsCard.currentPasswordInput.label"
                    )
                  )
                ),
              ]),
              _c("div", { staticClass: "bb-input-group password-input" }, [
                _vm.currentPasswordInputType === "checkbox"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.fields.currentPassword,
                          expression: "form.fields.currentPassword",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.form.fields.currentPassword)
                          ? _vm._i(_vm.form.fields.currentPassword, null) > -1
                          : _vm.form.fields.currentPassword,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.form.fields.currentPassword,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.form.fields,
                                  "currentPassword",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.form.fields,
                                  "currentPassword",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.form.fields, "currentPassword", $$c)
                          }
                        },
                      },
                    })
                  : _vm.currentPasswordInputType === "radio"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.fields.currentPassword,
                          expression: "form.fields.currentPassword",
                        },
                      ],
                      attrs: { type: "radio" },
                      domProps: {
                        checked: _vm._q(_vm.form.fields.currentPassword, null),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(
                            _vm.form.fields,
                            "currentPassword",
                            null
                          )
                        },
                      },
                    })
                  : _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.fields.currentPassword,
                          expression: "form.fields.currentPassword",
                        },
                      ],
                      attrs: { type: _vm.currentPasswordInputType },
                      domProps: { value: _vm.form.fields.currentPassword },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.form.fields,
                            "currentPassword",
                            $event.target.value
                          )
                        },
                      },
                    }),
                _c("i", {
                  class: _vm.currentPasswordIconClass,
                  on: {
                    click: function ($event) {
                      return _vm.toggleCurrentPasswordType()
                    },
                  },
                }),
              ]),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.errors.currentPassword,
                      expression: "form.errors.currentPassword",
                    },
                  ],
                  staticClass: "bb-invalid-feedback",
                },
                [_vm._v(" " + _vm._s(_vm.form.errors.currentPassword) + " ")]
              ),
            ]),
            _c("div", { staticClass: "bb-form-group" }, [
              _c("label", [
                _vm._v(
                  _vm._s(
                    _vm.$t("profile.personalDetailsCard.newPasswordInput.label")
                  )
                ),
              ]),
              _c("div", { staticClass: "bb-input-group new-password-input" }, [
                _vm.newPasswordInputType === "checkbox"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.fields.newPassword,
                          expression: "form.fields.newPassword",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.form.fields.newPassword)
                          ? _vm._i(_vm.form.fields.newPassword, null) > -1
                          : _vm.form.fields.newPassword,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.form.fields.newPassword,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.form.fields,
                                  "newPassword",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.form.fields,
                                  "newPassword",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.form.fields, "newPassword", $$c)
                          }
                        },
                      },
                    })
                  : _vm.newPasswordInputType === "radio"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.fields.newPassword,
                          expression: "form.fields.newPassword",
                        },
                      ],
                      attrs: { type: "radio" },
                      domProps: {
                        checked: _vm._q(_vm.form.fields.newPassword, null),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(_vm.form.fields, "newPassword", null)
                        },
                      },
                    })
                  : _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.fields.newPassword,
                          expression: "form.fields.newPassword",
                        },
                      ],
                      attrs: { type: _vm.newPasswordInputType },
                      domProps: { value: _vm.form.fields.newPassword },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.form.fields,
                            "newPassword",
                            $event.target.value
                          )
                        },
                      },
                    }),
                _c("i", {
                  class: _vm.newPasswordIconClass,
                  on: {
                    click: function ($event) {
                      return _vm.toggleNewPasswordType()
                    },
                  },
                }),
              ]),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.errors.newPassword,
                      expression: "form.errors.newPassword",
                    },
                  ],
                  staticClass: "bb-invalid-feedback",
                },
                [_vm._v(" " + _vm._s(_vm.form.errors.newPassword) + " ")]
              ),
            ]),
            _c("hr"),
            !_vm.$hasRole(_vm.acl.roles.owner)
              ? _c("div", { staticClass: "bb-form-group" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "calendarForm.advancedSettings.cancellationMarginInput.label"
                        )
                      )
                    ),
                  ]),
                  _c("p", { staticClass: "bb-input-description" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "calendarForm.advancedSettings.cancellationMarginInput.locationDescription"
                          )
                        ) +
                        " "
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "margin-wrapper" },
                    [
                      _c("BBSelect", {
                        staticClass: "places-select",
                        attrs: { options: _vm.placesAsOptions },
                        model: {
                          value: _vm.selectedPlace,
                          callback: function ($$v) {
                            _vm.selectedPlace = $$v
                          },
                          expression: "selectedPlace",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.selectedPlace,
                          expression: "selectedPlace",
                        },
                      ],
                      staticClass: "bb-input-description",
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "calendarForm.advancedSettings.cancellationMarginInput.description"
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.selectedPlace,
                          expression: "selectedPlace",
                        },
                      ],
                      staticClass: "margin-wrapper",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-start align-items-center",
                        },
                        [
                          _c("BBSelect", {
                            attrs: { options: _vm.daysOptions },
                            model: {
                              value: _vm.cancellationMarginObject.days,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.cancellationMarginObject,
                                  "days",
                                  $$v
                                )
                              },
                              expression: "cancellationMarginObject.days",
                            },
                          }),
                          _c(
                            "span",
                            { staticClass: "cancellation-margin-text" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "calendarForm.advancedSettings.cancellationMarginInput.daysLabel"
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-start align-items-center",
                        },
                        [
                          _c("BBSelect", {
                            attrs: { options: _vm.hoursOptions },
                            model: {
                              value: _vm.cancellationMarginObject.hours,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.cancellationMarginObject,
                                  "hours",
                                  $$v
                                )
                              },
                              expression: "cancellationMarginObject.hours",
                            },
                          }),
                          _c(
                            "span",
                            { staticClass: "cancellation-margin-text" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "calendarForm.advancedSettings.cancellationMarginInput.hoursLabel"
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-start align-items-center",
                        },
                        [
                          _c("BBSelect", {
                            attrs: { options: _vm.minutesOptions },
                            model: {
                              value: _vm.cancellationMarginObject.minutes,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.cancellationMarginObject,
                                  "minutes",
                                  $$v
                                )
                              },
                              expression: "cancellationMarginObject.minutes",
                            },
                          }),
                          _c(
                            "span",
                            { staticClass: "cancellation-margin-text" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "calendarForm.advancedSettings.cancellationMarginInput.minutesLabel"
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.errors.cancellationMargin,
                          expression: "form.errors.cancellationMargin",
                        },
                      ],
                      staticClass: "bb-invalid-feedback",
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.form.errors.cancellationMargin) + " "
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
          _c("hr", { staticClass: "mobile-divider" }),
        ]),
        _c(
          "b-modal",
          {
            ref: "cropImageModal",
            attrs: { id: "crop_image_modal" },
            scopedSlots: _vm._u([
              {
                key: "modal-header",
                fn: function ({ close }) {
                  return [
                    _c("div", { staticClass: "bb-modal-header" }, [
                      _c("h4", [
                        _vm._v(_vm._s(_vm.$t("profile.croperModal.title"))),
                      ]),
                      _c(
                        "button",
                        {
                          staticStyle: { "padding-left": "10px" },
                          on: { click: close },
                        },
                        [_c("i", { staticClass: "ki ki-close icon-md" })]
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "modal-footer",
                fn: function () {
                  return [
                    _c("div", { staticClass: "bb-modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "bb-btn btn-success btn-lg",
                          on: {
                            click: function ($event) {
                              return _vm.cropImage()
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("profile.croperModal.saveBtn")) +
                              " "
                          ),
                        ]
                      ),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          [
            _c("vue-cropper", {
              ref: "cropper",
              staticClass: "profile-picture-cropper",
              attrs: { src: _vm.uploadImageUrl },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "d-flex justify-content-end submit-btn-container" },
      [
        _c(
          "button",
          {
            staticClass: "bb-btn btn-success btn-lg",
            on: {
              click: function ($event) {
                return _vm.submit()
              },
            },
          },
          [_vm._v(" " + _vm._s(_vm.$t("profile.saveBtn")) + " ")]
        ),
      ]
    ),
    _c("div", { staticClass: "mobile-submit-btn-container" }, [
      _c(
        "button",
        {
          staticClass: "bb-btn btn-success btn-lg",
          on: {
            click: function ($event) {
              return _vm.submit()
            },
          },
        },
        [_vm._v(" " + _vm._s(_vm.$t("profile.saveBtn")) + " ")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }